<template>
  <div class="rules-group-container">
    <!--div class="rules-group-header"-->
    <!--div class="btn-group pull-right group-actions"-->

    <v-container fill-height fluid grid-list-xl>
      <v-layout justify-center wrap>

        <v-flex xs12 sm2 md2>
          <v-text-field label="Arm Name" v-model="three.name"> </v-text-field>
        </v-flex>

        <v-flex xs12 sm2 md2>
          <v-text-field
            label="Percentage %"
            v-model="three.percentage"
          ></v-text-field>
        </v-flex>

        <v-flex text-right xs2 sm6 md6>
          <v-switch  style="width:200px" v-model="three.collapse" label="Collapse"></v-switch>
        </v-flex>


        <v-flex xs2 sm2 md2 text-right>
          <v-btn v-if="!three.children.length" small color="primary" @click="addRule">Add Drug</v-btn>
          <v-btn  v-if="!three.children.length" @click="remove" small color="danger">Delete</v-btn>
        </v-flex>

        <v-flex xs12 sm12 md12 v-if="!three.collapse">
          <div class="rules-group-body">
            <div class="rules-list">
              <component
                v-for="(child, index) in three.children"
                :key="index"
                :is="child.type"
                :type="child.type"
                :three.sync="child.three"
                :index="index"
                :maxDepth="maxDepth"
                :depth="depth + 1"
                :drugs="drugs"
                v-on:child-deletion-requested="removeChild"
              >
              </component>
            </div>
          </div>
        </v-flex>

        <v-flex v-if="three.children.length && !three.collapse" xs12 sm12 md12 text-right>
          <v-btn small color="primary" @click="addRule">Add Drug</v-btn>
        </v-flex>

      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Drug from "./Drug.vue";
// import deepClone from "../utils/deepClone.js";

export default {
  name: "arm-group",

  components: {
    Drug,
  },

  props: ["type", "three", "index", "maxDepth", "depth", "drugs"],

  methods: {
    addRule() {
      const child = {
        type: "drug",
        three: {
        },
      };
      this.three.children.push(child);
      this.$emit("update:three", this.three);
    },

    remove() {
      this.$emit("child-deletion-requested", this.index);
    },

    removeChild(index) {
      this.three.children.splice(index, 1);
      this.$emit("update:three", this.three);
    },
  },

  data() {
    return {};
  },
  computed: {
    hasMultipleRule() {
      return this.three.children.length > 1;
    },
  },
};
</script>
